import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate } from 'react-router-dom'

export default function ClinicianSignup() {
  const [fullName, setFullName] = useState('')
  const [clinicName, setClinicName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [inviteCode, setInviteCode] = useState('')
  const [mode, setMode] = useState('new')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const navigate = useNavigate()

  async function handleSignup(e) {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: { emailRedirectTo: 'https://completept.app/login' }
    })
    if (authError) { setError(authError.message); setLoading(false); return }

    const userId = authData.user.id

    if (mode === 'new') {
      const { error: fnError } = await supabase.rpc('create_clinic_and_user', {
        clinic_name: clinicName,
        user_id: userId,
        user_full_name: fullName
      })
      if (fnError) { setError(fnError.message); setLoading(false); return }
    } else {
      const { data: clinic } = await supabase
        .from('clinics').select('id').eq('clinician_invite_code', inviteCode).single()
      if (!clinic) { setError('Invalid clinician invite code.'); setLoading(false); return }
      await supabase.from('users').insert({
        id: userId, full_name: fullName, role: 'clinician', clinic_id: clinic.id
      })
    }

    setSent(true)
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: '5rem 1.5rem 3rem', background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 50%, #0f766e 100%)', padding: '1.5rem', paddingTop: 'max(1.5rem, env(safe-area-inset-top))', paddingBottom: '3rem' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '2rem 2rem 1.5rem', background: 'linear-gradient(135deg, #0f766e, #0d9488)' }}>
          <p style={{ fontWeight: 800, fontSize: 20, color: 'white', letterSpacing: -0.5, margin: '0 0 1rem' }}>Complete PT</p>
          <p style={{ fontSize: 24, fontWeight: 700, color: 'white', lineHeight: 1.2, letterSpacing: -0.5, margin: '0 0 0.5rem' }}>Clinician sign up</p>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, margin: 0 }}>Create a new clinic or join an existing one</p>
        </div>

        <div style={{ padding: '2rem' }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: '1rem' }}>📧</div>
              <p style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 16, marginBottom: 8 }}>Check your email</p>
              <p style={{ fontSize: 14, marginBottom: '1.5rem' }}>We sent a confirmation link to <strong>{email}</strong>. Click it to activate your account.</p>
              <button className="secondary" onClick={() => navigate('/login')} style={{ width: '100%', padding: 14 }}>
                Back to sign in
              </button>
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', gap: 8, marginBottom: '1.5rem' }}>
                <button type="button" onClick={() => setMode('new')} style={{
                  flex: 1, padding: '10px', fontSize: 14,
                  background: mode === 'new' ? 'var(--brand)' : 'var(--surface)',
                  color: mode === 'new' ? 'white' : 'var(--text-primary)',
                  border: mode === 'new' ? 'none' : '1.5px solid var(--border)'
                }}>New clinic</button>
                <button type="button" onClick={() => setMode('join')} style={{
                  flex: 1, padding: '10px', fontSize: 14,
                  background: mode === 'join' ? 'var(--brand)' : 'var(--surface)',
                  color: mode === 'join' ? 'white' : 'var(--text-primary)',
                  border: mode === 'join' ? 'none' : '1.5px solid var(--border)'
                }}>Join clinic</button>
              </div>

              {error && <div className="alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
              <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 8, padding: '10px 14px', marginBottom: '1rem' }}>
                <p style={{ fontSize: 13, color: '#92400e', margin: 0, lineHeight: 1.5 }}>
                  <strong>Beta program:</strong> Please do not enter real patient data. This app is still in testing.
                </p>
              </div>

              <form onSubmit={handleSignup} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div className="form-field">
                  <label className="form-label">Your full name</label>
                  <input placeholder="Dr. Jane Smith" value={fullName} onChange={e => setFullName(e.target.value)} required />
                </div>
                {mode === 'new' ? (
                  <div className="form-field">
                    <label className="form-label">Clinic name</label>
                    <input placeholder="e.g. City Physio" value={clinicName} onChange={e => setClinicName(e.target.value)} required />
                  </div>
                ) : (
                  <div className="form-field">
                    <label className="form-label">Clinician invite code</label>
                    <input placeholder="Get this from your clinic admin" value={inviteCode} onChange={e => setInviteCode(e.target.value)} required style={{ letterSpacing: 1 }} />
                  </div>
                )}
                <div className="form-field">
                  <label className="form-label">Email address</label>
                  <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
                <div className="form-field">
                  <label className="form-label">Password</label>
                  <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={agreedToTerms} onChange={e => setAgreedToTerms(e.target.checked)} style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }} />
                  <div style={{ flexShrink: 0, width: 18, height: 18, borderRadius: 4, border: agreedToTerms ? 'none' : '1.5px solid #d1d5db', background: agreedToTerms ? 'var(--brand)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s' }}>
                    {agreedToTerms && <svg width="11" height="8" viewBox="0 0 11 8" fill="none"><path d="M1 4L4 7L10 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                  </div>
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
                    I agree to the{' '}
                    <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand)', fontWeight: 600 }}>Terms and Conditions</a>
                  </span>
                </label>
                <button type="submit" disabled={loading || !agreedToTerms} style={{ marginTop: 4, padding: 14, fontSize: 15 }}>
                  {loading ? 'Setting up...' : mode === 'new' ? 'Create clinic' : 'Join clinic'}
                </button>
              </form>

              <div style={{ borderTop: '1px solid var(--border)', marginTop: '1.5rem', paddingTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <p style={{ textAlign: 'center', margin: 0 }}>
                  Already have an account?{' '}
                  <span onClick={() => navigate('/login')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>Sign in</span>
                </p>
                <p style={{ textAlign: 'center', margin: 0 }}>
                  Are you a patient?{' '}
                  <span onClick={() => navigate('/signup')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>Sign up here</span>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
